var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSent = function SvgSent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.2 28.974v-27.5C.2.941.423.532.873.25 1.324-.034 1.8-.076 2.3.124l32.6 13.7c.6.267.9.733.9 1.4 0 .667-.3 1.134-.9 1.4l-32.6 13.7c-.5.2-.975.159-1.425-.125-.45-.283-.675-.692-.675-1.225Zm3-2.4 27.2-11.35-27.2-11.5v8.4l12.1 3.1-12.1 3v8.35Zm0-11.35v-11.5 22.85-11.35Z"
  })));
};
export default SvgSent;